module.exports = __webpack_public_path__ + "static/media/industry.a464422c.svg";